import type React from 'react'

import { memo } from 'react'

import {
  SummaryGridContainer,
  SummaryGridItem,
  SummaryItemLabel,
  SummaryItemValue,
  SummaryItemWrapper,
} from './styles'

export interface SummaryItem {
  label: string
  value: string | number | React.ReactNode
}

interface SummaryBannerGridProps {
  summaryItems: SummaryItem[]
  columns: number
  /**
   * When true, columns size to their content (`minmax(max-content, 1fr)`) so
   * long values aren't truncated and short ones don't waste space. Defaults to
   * equal-width columns (`minmax(0, 1fr)`). Opt in only for grids whose total
   * content reliably fits the container.
   */
  sizeColumnsToContent?: boolean
}

const renderSummaryItem = ({ label, value }: SummaryItem) => (
  <SummaryItemWrapper>
    <SummaryItemLabel label={label} />
    <SummaryItemValue value={value} />
  </SummaryItemWrapper>
)

/**
 * @deprecated Use `SummaryGrid` from `@moment/design-system-ui/summary-grid` instead.
 */
const SummaryBannerGrid: React.FC<SummaryBannerGridProps> = memo(
  ({ summaryItems, columns, sizeColumnsToContent = false }) => {
    return (
      <SummaryGridContainer
        columns={columns}
        sizeColumnsToContent={sizeColumnsToContent}
      >
        {summaryItems.map((item) => (
          <SummaryGridItem key={item.label}>
            {renderSummaryItem(item)}
          </SummaryGridItem>
        ))}
      </SummaryGridContainer>
    )
  },
)

SummaryBannerGrid.displayName = 'SummaryBannerGrid'

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default SummaryBannerGrid
